import { render, staticRenderFns } from "./ReportError.vue?vue&type=template&id=6d0f0153&scoped=true&"
import script from "./ReportError.vue?vue&type=script&lang=js&"
export * from "./ReportError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0f0153",
  null
  
)

export default component.exports